import { type ReactNode, type Ref } from 'react'
import { clsx } from 'clsx'

import Icon, { type IconTypes } from '@components/utils/Icon'

type IconTextProps = {
  icon: IconTypes
  children: ReactNode
  iconSize?: number
  className?: string
  'aria-label'?: string
  'data-testid'?: string
  ref?: Ref<HTMLSpanElement>
}

export const IconText = function IconText({
  icon,
  children,
  iconSize = 20,
  className,
  ref,
  ...props
}: IconTextProps) {
  return (
    <span ref={ref} {...props} className={clsx('tw:inline-flex tw:items-center tw:gap-1.5', className)}>
      <Icon type={icon} width={iconSize} height={iconSize} className="tw:text-gray-true-500" />
      {children}
    </span>
  )
}
